import React from "react";
import "./BannerMain.scss";
import { useNavigate } from "react-router-dom";
import portadabg from "../../assets/main_portada.png";
import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Button,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import AnimationComponent from "../AnimationComponent/AnimationComponent";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import admindefault from "../../assets/portada/admin.png";
import userdefault from "../../assets/portada/user.png";
import createInterviewImage from "../../assets/portada/admin.png";
import promptConfigImage from "../../assets/portada/general.png";
import questionsImage from "../../assets/portada/question.png";
import invitationsImage from "../../assets/portada/invitations.png";
import resultsImage from "../../assets/portada/result.png";
import summaryinterview from "../../assets/portada/summary.png";
import chatinterview from "../../assets/portada/chat.png";
import downloadexcel from "../../assets/portada/excel.png";
import resultai from "../../assets/portada/resultai.png";
import voice from "../../assets/portada/voice.png";
import { Home } from "@mui/icons-material";
import ChangeLanguage from "../ChangeLanguage";
import { useTranslation } from "react-i18next";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface Panel {
  id: string;
  image: string;
  title: string;
  description: string;
}

interface FunctionalitiesIGPTProps {
  panels: Panel[];
  typePanel: string;
}

function FunctionalitiesIGPT({ panels, typePanel }: FunctionalitiesIGPTProps) {
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange =
    (panelId: string) => (_: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panelId : false);
    };

  const currentImage =
    panels.find((p) => p.id === expanded)?.image ||
    (typePanel === "admin" ? admindefault : userdefault);

  return (
    <div className="content_functionality">
      {typePanel === "admin" ? (
        <h2>Administrator Features</h2>
      ) : (
        <h2>User Features</h2>
      )}

      <div className="content_functionality__body">
        <div className="content_functionality__list">
          {panels.map(({ id, title, description }) => (
            <Accordion
              key={id}
              expanded={expanded === id}
              onChange={handleChange(id)}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`${id}-content`}
                id={`${id}-header`}
              >
                <Typography>{title}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  component="div"
                  style={{ whiteSpace: "pre-line", lineHeight: 1.6 }}
                >
                  {description}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </div>

        <div className="content_functionality__container_image">
          <img
            src={currentImage}
            alt="Feature illustration"
            className="content_functionality__image"
          />
        </div>
      </div>
    </div>
  );
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const BannerMain: React.FC = () => {
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const panels_admin = [
    {
      id: "panel1",
      title: `${t("general.banner.admin.creation")}`,
      description: `
    ${t("general.banner.admin.creationdescription")}

    `.trim(),
      image: createInterviewImage,
    },
    {
      id: "panel2",
      title: `${t("general.banner.admin.prompt")}`,
      description: `${t("general.banner.admin.promptdescription")}`.trim(),
      image: promptConfigImage,
    },
    {
      id: "panel3",
      title: `${t("general.banner.admin.question")}`,
      description: `${t("general.banner.admin.questiondescription")}
    `.trim(),
      image: questionsImage,
    },
    {
      id: "panel4",
      title: `${t("general.banner.admin.invitation")}`,
      description: `${t("general.banner.admin.invitationdescription")}
`.trim(),
      image: invitationsImage,
    },
    {
      id: "panel5a",
      title: `${t("general.banner.admin.dashboard")}`,
      description: `${t("general.banner.admin.dashboarddescription")}`.trim(),
      image: resultsImage,
    },
    {
      id: "panel5b",
      title: `${t("general.banner.admin.aiAnalysis")}`,
      description: `${t("general.banner.admin.aiAnalysisdescription")}`.trim(),
      image: summaryinterview,
    },
    {
      id: "panel5c",
      title: "Live Chat",
      description: `${t("general.banner.admin.chatdescription")}`.trim(),
      image: chatinterview,
    },

    {
      id: "panel6",
      title: `${t("general.banner.admin.download")}`,
      description: `${t("general.banner.admin.downloaddescription")}`.trim(),
      image: downloadexcel,
    },
  ];

  const panels_user = [
    {
      id: "panel1",
      title: "Interactive Chat",
      description: `${t("general.banner.user.chatinteractive")}`.trim(),
      image: userdefault,
    },
    {
      id: "panel2",
      title: "Follow-Up Questions",
      description: `${t("general.banner.user.followupq")}`.trim(),
      image: userdefault,
    },
    {
      id: "panel4",
      title: "Voice Input Support",
      description: `${t("general.banner.user.voiceuser")}`.trim(),
      image: voice,
    },
    {
      id: "panel3",
      title: `${t("general.banner.user.finalreview")}`,
      description: `${t("general.banner.user.finalreviewdescription")}`.trim(),
      image: resultai,
    },
  ];

  const handlelogin = () => {
    navigate("/login");
  };

  return (
    <div className="banner">
      <section className="banner-main">
        <div
          style={{
            position: "absolute",
            top: 0,
            right: "20px",
          }}
        >
          {" "}
          <ChangeLanguage />
        </div>

        <div className="banner-main__content">
          <h1 className="banner-main__title">Interview GPT</h1>
          <p className="banner-main__subtitle">{t("general.banner.slogan")}</p>
          <div className="banner-main__buttons">
            <Button
              onClick={() => handlelogin()}
              style={{ background: "#356a89", margin: "0px", height: "50px" }}
            >
              {t("general.banner.login")}
            </Button>
          </div>
        </div>
        <div className="banner-main__container_image" style={{ zIndex: "200" }}>
          <img
            src={portadabg}
            alt="Inteviewgpt-image"
            className="banner-main__image"
          />
        </div>
      </section>
      <section className="banner_secondary">
        <Box>
          <Box sx={{ borderBottom: 1, borderColor: "divider", px: 2 }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="Tabs example"
              textColor="primary"
              indicatorColor="primary"
              variant="scrollable"
            >
              <Tab label={t("general.banner.overview")} {...a11yProps(0)} />
              <Tab label={t("general.banner.features")} {...a11yProps(1)} />
              <Tab label={t("general.banner.developedby")} {...a11yProps(2)} />
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <div style={{ marginBottom: "40px" }}>
              <p>
                <h2>Interview GPT</h2>
                {t("general.banner.description")}
              </p>

              <p>{t("general.banner.types")}</p>
              <ul>
                <li>
                  <strong>Chat Mode</strong>:{" "}
                  {t("general.banner.chatmodedescription")}
                </li>
                <li>
                  <strong>Sequential Mode</strong>:{" "}
                  {t("general.banner.sequentialmodedescription")}
                </li>
              </ul>

              <p>{t("general.banner.benefits")}</p>
              <ul>
                <li>{t("general.banner.voice")}</li>
                <li>{t("general.banner.analysis")}</li>
              </ul>

              <p>{t("general.banner.adminbenefit")}</p>
              <ul>
                <li> {t("general.banner.results")}</li>
                <li>{t("general.banner.chart")}</li>
                <li>{t("general.banner.livechat")}</li>
              </ul>
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <FunctionalitiesIGPT panels={panels_admin} typePanel={"admin"} />
            <FunctionalitiesIGPT panels={panels_user} typePanel={"user"} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <div className="version-info">
              <h3>{t("general.banner.releaseinfo")}</h3>
              <ul>
                <li>
                  <strong>TechLab Portal:</strong>{" "}
                  <a
                    href="https://idbg.sharepoint.com/sites/tech_lab#/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    idbg.sharepoint.com/sites/tech_lab
                  </a>
                </li>
                <li>
                  <strong>{t("general.banner.contact")}</strong>{" "}
                  <a href="mailto:support@iadb.org">techlab@iadb.org</a>
                </li>
                <li>
                  <strong>Tech Stack:</strong> Node 16, React 17, TypeScript,
                  MUI v5, Azure AD
                </li>
                <li><strong>Team:</strong></li>
                <ul>
                  
                  <li>Alejandra Perez</li>
                  <li>Jhoselyn Pajuelo</li>
                  <li>Ignacio Cerrato</li>
                  <li>Jose Daniel Zarate</li>
                </ul>
              </ul>
            </div>
          </CustomTabPanel>
        </Box>
      </section>
      <footer className="footer-main">
        <div className="footer-content">© TechLab. All rights reserved.</div>
      </footer>
    </div>
  );
};

export default BannerMain;
